// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__ru4Sz","question":"Question_question__163-Z","description":"Question_description__j1CpU"};